module.exports = __webpack_public_path__ + "img/IMG_0204.e40e1247.jpg";